// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1Zo0_","Label":"BuildControl_Label__WT7n5","Less":"BuildControl_Less__2DFCq","More":"BuildControl_More__OLu9_"};